export class GcpEncryptionKeys {
    'keys';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keys",
            "baseName": "keys",
            "type": "Array<GcpEncryptionKey>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpEncryptionKeys.attributeTypeMap;
    }
    constructor() {
    }
}
